module.exports = __webpack_public_path__ + "img/09.b2a4b66b.png";